export const MAX_CLUSTER_LEAVES = Infinity;
export const FIELD_ZOOM_LEVEL = 14;
export const COLLAPSED_SHEET_HEIGHT_PX = 300;
